import io from "socket.io-client";
import Config from '../constants/config';
import CryptoJS from "crypto-js";
import Protocol from "bin-protocol";


// Encrypts plain text into cipher text
function encrypt(plainText) {
    const ALGORITHM = 'aes-256-cbc';
    const CIPHER_KEY = "abcdefghijklmnopqrstuvwxyz012345";//Config.salt;
    const BLOCK_SIZE = 16;

    let iv = CryptoJS.lib.WordArray.random(BLOCK_SIZE);
    const key = CryptoJS.enc.Utf8.parse(CIPHER_KEY);
    const cipherText = CryptoJS.AES.encrypt(plainText, key, { iv })
    const actual = cipherText.iv + cipherText.ciphertext;
    console.log('cipher text', cipherText.ciphertext);
    return cipherText.toString();
}

export const GPSinaSocketListners = {
    ALL: "ALL",
    Connect: 'Connect',
    Message: 'Message',
    AllDevices: 'AllDevices',
    GpsData: 'GpsData',
    BatteryVoltage: 'BatteryVoltage',
    AlarmData: 'AlarmData',
    DeviceSetting: 'DeviceSetting',
    DeviceStatusChanged: 'DeviceStatusChanged',
    EngineStatus: 'EngineStatus',
    DeviceSignal: 'DeviceSignal',
}

export default class SocketManager {

    socket = null;
    static singleton = null;

    constructor() {
        this.listeners = {};
        this.isConnected = false;
        this.hash = null;
        this.callback = () => null;
    }

    static getInstance() {
        if (SocketManager.singleton == null) {
            SocketManager.singleton = new SocketManager();
        }
        return SocketManager.singleton;
    }

    addListeners = (listenerName, listenerFunc) => {
        console.log('socket:: adding listener', listenerName);
        if (GPSinaSocketListners[listenerName] && !this.listeners[listenerName]) this.listeners[listenerName] = listenerFunc;
    }

    removeListeners = (listenerName) => {
        if (GPSinaSocketListners[listenerName] && this.listeners[listenerName]) delete this.listeners[listenerName];
    }

    removeAllListeners = (from) => {
        console.log('socket:: removeAllListeners', from);
        this.listeners = {};
    }
    /**
     * connect
     * @param userEmail user email.
     * @param token user hashed token.
     * Function contains all the socket events
     */
    connect = (userEmail, token, devicesCallBack, gpsCallBack, batteryCallBack, alarmsCallBack, deviceSettingCallBack, deviceStatusCallBack, engineCallBack, deviceSignalCallBack, hideLoader) => {
        this.connectSocket(userEmail, token, devicesCallBack, gpsCallBack, batteryCallBack, alarmsCallBack, deviceSettingCallBack, deviceStatusCallBack, engineCallBack, deviceSignalCallBack, hideLoader).then(object => {
            this.socket = object;

            //on connection
            this.socket.on('connect', () => {
                this.isConnected = true;
                console.log("socket:: SOCKET CONNECT RECEIVED");
                if (typeof this.listeners[GPSinaSocketListners.Connect] === "function") this.listeners[GPSinaSocketListners.Connect]({ connected: true });
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ connected: true });
                // this.sendToSocket('login', userEmail, token, hideLoader);
                let data = this.PackStringWeb(userEmail, []);
                data = this.PackStringWeb(token, data);
                data = this.convertStringArrayToByteArray(data);
                this.socket.emit('webLogin', data);
            })

            this.socket.on('login', () => {
                console.log("socket:: SOCKET LOGIN RECEIVED");
            })

            this.socket.on("connect_error", error => {
                console.log("socket:: SOCKET CONNECT ERROR RECEIVED: ", error);
            })

            this.socket.on('message', (data) => {
                if (typeof this.listeners[GPSinaSocketListners.Message] === "function") this.listeners[GPSinaSocketListners.Message](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "message", ...data });
                console.log("socket:: SOCKET MESSAGE RECEIVED", data);
                if (data.Code === 3) {
                    hideLoader();
                }
            })

            this.socket.on('deviceData', (data) => {
                console.log("socket::SOCKET DEVICE DATA RECEIVED", data);
            })

            this.socket.on('setting-received', (data) => {
                console.log("socket::setting-received", data);
                // engineCallBack(data);
            });

            this.socket.on('all-devices', (data) => {
                console.log("socket::'all-devices'", data);
                if (typeof this.listeners[GPSinaSocketListners.AllDevices] === "function") this.listeners[GPSinaSocketListners.AllDevices](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "all-devices", ...data });
                devicesCallBack(data);
            });

            this.socket.on('gps-data', (data) => {
                console.log("socket::'gps-data'", data);
                if (typeof this.listeners[GPSinaSocketListners.GpsData] === "function") this.listeners[GPSinaSocketListners.GpsData](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "gps-data", ...data });
                gpsCallBack(data);
            });

            this.socket.on('battery-voltage', (data) => {
                console.log("socket::'battery-voltage", data);
                if (typeof this.listeners[GPSinaSocketListners.BatteryVoltage] === "function") this.listeners[GPSinaSocketListners.BatteryVoltage](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "battery-voltage", ...data });
                batteryCallBack(data);
            });

            this.socket.on('alarm-data', (data) => {
                console.log("socket::'alarm-data'", data);
                if (typeof this.listeners[GPSinaSocketListners.AlarmData] === "function") this.listeners[GPSinaSocketListners.AlarmData](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "alarm-data", ...data });
                alarmsCallBack(data);
            });

            this.socket.on('device-setting', (data) => {
                console.log("socket::'device-setting'", data);
                if (typeof this.listeners[GPSinaSocketListners.DeviceSetting] === "function") this.listeners[GPSinaSocketListners.DeviceSetting](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "device-setting", ...data });
                // console.log("device-setting",data);
                this.callback(data);
                this.callback = () => null;
                deviceSettingCallBack(data);
            });

            this.socket.on('device-status-changed', (data) => {
                console.log("socket::'device-status-changed", data);
                if (typeof this.listeners[GPSinaSocketListners.DeviceStatusChanged] === "function") this.listeners[GPSinaSocketListners.DeviceStatusChanged](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "device-status-changed", ...data });
                deviceStatusCallBack(data);
            });

            this.socket.on('engine-status', (data) => {
                console.log("socket::'engine-status',", data);
                if (typeof this.listeners[GPSinaSocketListners.EngineStatus] === "function") this.listeners[GPSinaSocketListners.EngineStatus](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "engine-status", ...data });
                engineCallBack(data);
            });

            this.socket.on('device-signal', (data) => {
                console.log("socket::'device-signal'", data);
                if (typeof this.listeners[GPSinaSocketListners.DeviceSignal] === "function") this.listeners[GPSinaSocketListners.DeviceSignal](data);
                if (typeof this.listeners[GPSinaSocketListners.ALL] === "function") this.listeners[GPSinaSocketListners.ALL]({ name: "device-signal", ...data });
                deviceSignalCallBack(data);
            });

        }).catch(err => {
            console.log(err);
        });
    }

    /**
     * disconnect
     * Function disconnect socket events
     */
    disconnect = () => {
        this.isConnected = false;
        this.listeners = {}
        if (this.socket) this.socket.disconnect();
    }

    isSocketConnected = () => {
        return this.isConnected;
    }

    getGPSData = (devices) => {
        if (devices !== undefined && devices.length) {
            this.socket.emit('updateGPSDevices', devices.map(d => d.deviceID)); //calling UPDATE GPS DEVICES EVENT
        }
    }

    leaveGPSData = (devices) => {
        if (devices !== undefined && devices.length) {
            this.socket.emit('leaveGPSDevices', devices.map(d => d.deviceID)); //calling UPDATE GPS DEVICES EVENT
        }
    }

    sendSettings = (DeviceID, Command, Data, callback) => {
        let singleString = this.encodeSetting(DeviceID, Command, Data)
        console.log("Strign", singleString);
        console.log("Data", this.convertStringArrayToByteArray(singleString));

        this.socket.emit('sendSettingToDevice', this.convertStringArrayToByteArray(singleString));
        this.callback = callback;
    }
    /**
     * Connect Socket
     * Function will send request on webserver for connection
     */
    connectSocket = (userEmail, token, devicesCallBack, gpsCallBack, batteryCallBack, alarmsCallBack, deviceSettingCallBack, deviceStatusCallBack, engineCallBack, lockCallBack, hideLoader) => {
        const _this = this;
        return new Promise(function (resolve, reject) {
            let connection = io(Config.et_socket_url, { transports: ["websocket"], extraHeaders: {} });
            if (connection) {
                console.log("SOCKET SUCCESS: ", connection);
                resolve(connection);
            } else {
                if (connection.match("error:websocket: bad handshake")) {
                    _this.connectSocket(userEmail, token, devicesCallBack, gpsCallBack, batteryCallBack, alarmsCallBack, deviceSettingCallBack, deviceStatusCallBack, engineCallBack, lockCallBack, hideLoader)
                }
                //err bed hand shake
                console.log("SOCKET FAILURE");
                reject('Error: while connecting socket !');
            }
        });
    }

    sendToSocket = (event, userEmail, token, hideLoader) => {
        var encodedToken = this.encodeData(token, userEmail);
        this.hash = encodedToken;
        console.log("socket:: sendToSocket: ", userEmail, token, event);
        this.socket.emit(event, this.convertStringArrayToByteArray(encodedToken));

        setTimeout(() => {
            hideLoader();
        }, 5000)
    }

    emitEvent = (eventName) => {
        if (this.isConnected && this.hash) this.socket.emit(eventName);
    }

    /**
     * Convert every character of array into their ASCHII code .
     * @param stringArray character.
     */
    convertStringArrayToByteArray(stringArray) {
        var simpleArray = [];
        for (var i = 0; i < stringArray.length; i++) {
            let char = stringArray[i];
            if (typeof char !== 'number') {
                var conversion = char.charCodeAt();
                simpleArray.push(conversion);
            } else {
                simpleArray.push(char);
            }
        }
        return simpleArray;
    }

    /**
     * Encode Token and user email
     * @param token client token.
     * @param email user email.
     */
    encodeData(token, email) {
        var data;
        data = this.PackString(email, data);
        data = this.PackString(token, data);
        return data;
    }

    encodeSetting(id, command, values) {
        var data;
        data = this.PackString(id, data);
        data = this.PackString(command, data);
        data = this.PackString(values, data);
        return data;
    }

    /**
     * Pack string
     * @param stringVal devices list.
     * @param dataArray token array.
     */
    PackString(stringVal, dataArray) {
        var length;
        var data = dataArray;
        length = stringVal.length;
        if (length > 65535 && length < 0) {
            return dataArray;
        }
        var protocol = new Protocol();
        var buffer = protocol.write().UVarint(length).result;
        var combined;
        if (dataArray == null) {
            var combined = buffer;
        } else {
            // var convertedLength = [...dataArray, ...buffer];
            // combined = [...convertedLength, ...data];
            combined = [...dataArray, ...buffer]
        }
        combined = [...combined, ...stringVal.toString(16)];
        return combined;
    }

    PackStringWeb(stringVal, dataArray) {
        var length;
        var data = dataArray;
        length = stringVal.length;
        if (length > 65535 && length < 0) {
            return dataArray;
        }
        const buffer = this.PackInt32(stringVal.length);
        var combined;
        if (dataArray == null) {
            var combined = buffer;
        } else {
            combined = [...dataArray, ...buffer]
        }
        combined = [...combined, ...stringVal];
        return combined;
    }

    PackInt32(numberValue) {
        const a = new Uint8Array(new ArrayBuffer(4));
        a[0] = numberValue >> 24;
        a[1] = numberValue >> 16;
        a[2] = numberValue >> 8;
        a[3] = numberValue;
        return a;
    }

    /**
     * Disconnect socket server connection on screen change.
     */
    disconnectSocketServer = () => {
        console.log('SOCKET HARD CLOSE', this.socket);
        if (this.socket) {
            this.isConnected = false;
            console.log('SOCKET CLOSED');
            this.socket.close(1000);
            this.socket = null;
        }
    };
}